import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Banner = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [banners, setBanners] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        getBanners()
    }, [])

    const getBanners = () => {
        ApiHelper.get(API_ENDPOINTS.BANNER).then((res) => {
            if (res.status === 200) {
                setBanners(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.bannerTitle ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/banners/edit/${rowData.bannerId}`)} >
                    {rowData?.bannerTitle}
                </div>
            ) : null
        );
    };

    const webImageBodyTemplate = (rowData) => {
        return (
            rowData.bannerWebImage ? (
                <img src={`${process.env.REACT_APP_BASE_URL}/${rowData.bannerWebImage}`} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }} alt="" style={{ width: 'auto', height: '50px', objectFit: 'cover' }} />
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const mobileImageBodyTemplate = (rowData) => {
        return (
            rowData.bannerMobileImage ? (
                <img src={`${process.env.REACT_APP_BASE_URL}/${rowData.bannerMobileImage} `} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }} alt="" style={{ width: 'auto', height: '50px', objectFit: 'cover' }
                } />
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'} `}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/banners/edit/${rowData.bannerId} `)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.bannerId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteBanner(id),
        });
    };

    const deleteBanner = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.BANNER}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getBanners()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Banners</p></span></h4>
                            <Link class="btn btn-primary" to={'/banners/add'} >Add New Banner</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={banners} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Title' body={nameBodyTemplate} field='bannerTitle' />
                                            <Column sortable header='URL' field='bannerUrl' />
                                            <Column sortable header='Web Image' body={webImageBodyTemplate} />
                                            <Column sortable header='Mobile Image' body={mobileImageBodyTemplate} />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                            <Column sortable header='Action' body={actionBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Banner
